import type {Snapshot} from '@platform/contracts/x';

// Both catalogue selection and the live-card shortcut obey the same basket limits.
export function addDraftCard(state:Snapshot,ids:string[],id:string):{ids:string[];error?:'selection.limit'|'purchase.card_limit'}{
 if(ids.includes(id))return {ids};
 if(ids.length>=state.tombala.limits.maximumCardsPerCommand)return {ids,error:'selection.limit'};
 const owned=new Set(state.cards.filter(card=>card.ownMinor>0).map(card=>card.id));
 const maximum=state.tombala.limits.maximumActiveCardsPerPlayer??state.cards.length;
 if(!owned.has(id)&&owned.size+ids.filter(value=>!owned.has(value)).length>=maximum)return {ids,error:'purchase.card_limit'};
 return {ids:[...ids,id]};
}
